module.exports = __webpack_public_path__ + "img/gridhub.3eedb754.svg";